import { fetchQuery, graphql } from "relay-runtime"
import {
  AiRequestMetadataInput,
  chChatCaseSummaryConfirmationMessageQuery as chChatCaseSummaryConfirmationMessageQueryType,
} from "@/modules/chats/services/ai/ch/__generated__/chChatCaseSummaryConfirmationMessageQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query chChatCaseSummaryConfirmationMessageQuery($aiRequestMetadata: AiRequestMetadataInput!) {
    chatCaseSummaryConfirmationMessage: ch_chatCaseSummaryConfirmationMessage(aiRequestMetadata: $aiRequestMetadata) {
      text
      result
      fileHash
      aiRequestDurationMs
      aiAnonymizationRequestDurationMs
    }
  }
`

export const chChatCaseSummaryConfirmationMessageQuery = (aiRequestMetadata: AiRequestMetadataInput) => {
  return fetchQuery<chChatCaseSummaryConfirmationMessageQueryType>(RelayEnvironment, query, {
    aiRequestMetadata,
  }).toPromise()
}
